const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
const MAX_BYTES = 512 * 1024;

export type ValidateResult = { ok: true } | { ok: false; reason: string };

/**
 * Client-side gate for uploaded asset icons (AVP-851): raster allow-list
 * (PNG/JPEG/WebP — SVG and everything else rejected) and a hard size cap.
 * The backend (AVP-847) re-encodes/validates too; this gives fast feedback.
 */
export const validateIcon = (file: File): ValidateResult => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    return { ok: false, reason: 'Unsupported file type. Use PNG, JPEG or WebP.' };
  }
  if (file.size === 0) {
    return { ok: false, reason: 'The selected file is empty.' };
  }
  if (file.size > MAX_BYTES) {
    return { ok: false, reason: `Image is too large (max ${Math.round(MAX_BYTES / 1024)} KB).` };
  }
  return { ok: true };
};
